import { BaseModel } from "../../../infrastructure/model/base/BaseModel";
import BaseResponse from "../../../infrastructure/model/base/BaseResponse";
import UOMService from "../../../infrastructure/services/UomService";
import HttpUtils from "../../utils/HttpUtils";
import { BaseCommonApiUseCaseDeps } from "./CommonApiUseCase";


interface InsertUOMUseCaseDeps extends BaseCommonApiUseCaseDeps {
  param: BaseModel;
}

interface DeleteUOMUseCaseDeps extends BaseCommonApiUseCaseDeps {
  id: number;
}

export const getListUoMUseCase = async (deps: BaseCommonApiUseCaseDeps): Promise<BaseModel[]> => {
  const { setLoading, showError } = deps;
  try {
    setLoading?.(true);
    let dataMapper: BaseModel[] = [];
    const res = await UOMService.getListUOM();
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccessWithData(res) {
        dataMapper = res.data;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const insertUoMUseCase = async (
  deps: InsertUOMUseCaseDeps
): Promise<BaseModel | undefined> => {
  const { param, setLoading, showError, showSuccess } = deps;
  try {
    setLoading?.(true);
    let dataMapper: BaseModel | undefined = undefined;
    let res: BaseResponse<BaseModel> = {} as BaseResponse<BaseModel>;
    if (param.id === 0) {
      res = await UOMService.createNewUOM(param.name);
    } else {
      res = await UOMService.updateUOM(param.id, param.name);
    }
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccessWithData(res) {
        showSuccess?.();
        dataMapper = res.data;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const deleteUoMUseCase = async (deps: DeleteUOMUseCaseDeps): Promise<boolean> => {
  const { id, setLoading, showError, showSuccess } = deps;
  try {
    setLoading?.(true);
    let dataMapper = false;
    const res = await UOMService.deleteUOM(id);

    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccess() {
        showSuccess?.();
        dataMapper = true
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};